const farmRouter = [
    {
        path: "list-farm",
        name: "farm",
        component: () => import("@/views/admin/farm"),
        default: true,
        meta: {
            model: "farm",
            // requiresAuth: true,
        },
    },
    {
        path: "list-farm/add",
        name: "addFarm",
        component: () => import("@/views/admin/farm/function"),
        default: true,
        meta: {
            model: "farm",
            // requiresAuth: true,
        },
    },
    {
        path: "list-farm/edit/:id",
        name: "editFarm",
        component: () => import("@/views/admin/farm/function"),
        default: true,
        meta: {
            model: "farm",
            // requiresAuth: true,
        },
    },
    {
        path: "list-farm/kind",
        name: "farmKind",
        component: () => import("@/views/admin/farm/kind"),
        default: true,
        meta: {
            model: "kind_type",
            // requiresAuth: true,
        },
    },
];
export default farmRouter;